var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHostIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7175 1.14846C40.3998 -0.0244202 42.7293 -0.0244202 44.4116 1.14846L68.9997 13.9198V61.4864H49.7174L37.6822 79.7311V65.5263L45.5763 53.6672H61.235V18.8719L41.5645 8.70697L21.894 18.8719V53.6672H37.5528V61.6167H14V14.05L38.7175 1.14846Z",
    fill: "#57486D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostIcon);
export default __webpack_public_path__ + "static/media/host-icon.ae05d8c54ba930d07d80e6cc4f7e0a36.svg";
export { ForwardRef as ReactComponent };